import {
  ADD_ANOVA,
  ADD_GROUP_TO_FILTERING_PROFILE_BLACKLIST,
  ADD_GROUP_TO_FILTERING_PROFILE_WHITELIST,
  ADD_TUKEY,
  CLEAR_RESULT_MAP_SITE,
  CREATE_FILTERING_PROFILE,
  DELETE_FILTERING_PROFILE,
  DELETE_FILTERING_PROFILE_FILTER,
  ENABLE_EDITION_MODE,
  FEATURES_BY_DATE_FAILED,
  FULL_RESET_RESULT_MAP,
  REFRESHING_FEATURES_BY_DATE,
  REFRESHING_RESULT_MAP,
  REMOVE_FOCUSED_VARIETY,
  REMOVE_GROUP_FROM_FILTERING_PROFILE_BLACKLIST,
  REMOVE_GROUP_FROM_FILTERING_PROFILE_WHITELIST,
  REMOVE_TRAIT_FROM_AUC_DATA,
  RESET_ANOVA,
  RESET_FILTERING_PROFILE,
  RESET_FILTER_BY_STATUS,
  RESET_RESULT_MAP,
  RESET_SCOUTING,
  SET_ATTRIBUTES_FILTER,
  SET_AUC_DATA,
  SET_COLOR_SCALE_STEP,
  SET_EXPERIMENTS_FILTER,
  SET_FAVORITE_VARIETIES,
  SET_FEATURES_BY_DATE,
  SET_FILTERING_PROFILE,
  SET_FILTERING_PROFILES,
  SET_FILTERING_PROFILE_FILTER,
  SET_FILTERING_PROFILE_SCOPE,
  SET_FILTER_BY_STATUS_MODE,
  SET_FOCUSED_VARIETIES,
  SET_LAYER_FILTER,
  SET_LINEAR_RULER_ACTIVE,
  SET_MAP_DISPLAY_MODE,
  SET_MAP_MODE,
  SET_MODALITIES_FILTER,
  SET_NEW_FEATURE_PROPERTIES,
  SET_PENDING_FIELD_BOOK_COLORS,
  SET_PLOT_LABELS_VISIBLE,
  SET_PLOT_LABEL_OPACITY,
  SET_PLOT_LABEL_PROPERTY,
  SET_PLOT_MAP_COLORING,
  SET_PLOT_MAP_OPACITY,
  SET_RESULT_MAP_FEATURES,
  SET_SCOUTING_COLOR_SCALE_STEP,
  SET_SCOUTING_DATES,
  SET_SCOUTING_FEATURES,
  SET_SCOUTING_TRAITS,
  SET_SELECTED_ANOVA_INDEX,
  SET_SELECTED_ATTRIBUTE,
  SET_SELECTED_CONTRACT,
  SET_SELECTED_PLOT_ID,
  SET_SELECTED_SCOUTING_FEATURE,
  SET_SELECTED_SCOUTING_TRAIT,
  SET_SELECTED_TRAIT,
  SET_TRAITS,
  SET_TRIAL_EXPERIMENT_STATUS,
  SET_VISUALIZED_VARIETIES,
  UPDATE_FILTERING_PROFILE,
  UPSERT_MAP_LAYER,
} from "./actionTypes";
import { hasExperimentsRole, hasFeaturesRole } from "../users/rolesUtil";
import {
  requestFeaturesPropertiesByDate,
  requestFetchClientExperiments,
  requestFetchFilteringProfiles,
  requestFetchPlotRatings,
  requestFetchResultMapFeatures,
  requestFetchScoutingFeatures,
  requestFetchTraitGroups,
  requestUpdateFilteringProfile,
} from "../services/backendRequests";

import { MAX_GENOTYPE_SELECTION } from "../constants";
import { addDangerAlert } from "./alerts";
import { format } from "date-fns";

export function setResultMapFeatures(
  contract,
  trial,
  features,
  traits,
  trialDate,
  experiments,
  plot_ratings,
  filteringProfiles
) {
  return {
    type: SET_RESULT_MAP_FEATURES,
    contract,
    trial,
    features,
    traits,
    trialDate,
    experiments,
    plot_ratings,
    filteringProfiles,
  };
}

export function updateFeatureProperties(newProperties) {
  return {
    type: SET_NEW_FEATURE_PROPERTIES,
    newProperties,
  };
}

function setFeaturesByDate(featuresByDate, traits) {
  return (dispatch) => {
    dispatch({
      type: SET_FEATURES_BY_DATE,
      featuresByDate,
      traits,
    });
  };
}

export function setSelectedPlotId(selectedPlotId) {
  return (dispatch) => {
    dispatch({
      type: SET_SELECTED_PLOT_ID,
      selectedPlotId,
    });
  };
}

export function setSelectedTrait(trait) {
  return (dispatch) => {
    dispatch({
      type: SET_SELECTED_TRAIT,
      trait,
    });
  };
}

export function setColorScaleStep(step) {
  return (dispatch) => {
    dispatch({
      type: SET_COLOR_SCALE_STEP,
      step,
    });
  };
}

export function setScoutingColorScaleStep(step) {
  return (dispatch) => {
    dispatch({
      type: SET_SCOUTING_COLOR_SCALE_STEP,
      step,
    });
  };
}

function refreshingResultMap() {
  return {
    type: REFRESHING_RESULT_MAP,
  };
}

function refreshingFeaturesByDate() {
  return {
    type: REFRESHING_FEATURES_BY_DATE,
  };
}

export function resetResultMapFeatures() {
  return (dispatch) => {
    dispatch({
      type: RESET_RESULT_MAP,
    });
  };
}

/**
 * Remove company object from store on logout
 */
export function fullResetResultMap() {
  return (dispatch) => {
    lastScoutingRequest++;
    dispatch({
      type: FULL_RESET_RESULT_MAP,
    });
  };
}

export function fetchResultMapFeatures(
  trial,
  trialDate,
  refreshExperiments = true
) {
  return async (dispatch, getState) => {
    // call refreshing to display spinner because it could be long to get data
    dispatch(refreshingResultMap());

    const contractInfo = getState().user.contracts.find(
      (contract) => contract.id === trial?.contract_id
    );

    try {
      let features = [];
      let plot_ratings = [];
      let filteringProfiles = [];
      let experiments;

      if (hasFeaturesRole(contractInfo?.roles)) {
        if (!getState().traits.all.length) {
          const trait_groups = await requestFetchTraitGroups(getState().user);
          dispatch({ type: SET_TRAITS, traitGroups: trait_groups });
        }

        await Promise.all([
          requestFetchResultMapFeatures(getState().user, trial, trialDate),
          requestFetchPlotRatings(getState().user, trial, trialDate),
          requestFetchFilteringProfiles(getState().user, trial),
        ]).then(([featureData, plotRatingData, filteringProfilesData]) => {
          features = featureData;
          plot_ratings = plotRatingData;
          filteringProfiles = filteringProfilesData;
        });
      }

      if (refreshExperiments && hasExperimentsRole(contractInfo?.roles))
        experiments = await requestFetchClientExperiments(
          trial,
          getState().user
        );

      dispatch(
        setResultMapFeatures(
          contractInfo,
          trial,
          features,
          getState().traits.all,
          trialDate,
          experiments,
          plot_ratings,
          filteringProfiles
        )
      );
    } catch (err) {
      dispatch(addDangerAlert(err));
    }
  };
}

export function setFilteringProfileScope(scope) {
  return (dispatch) => {
    dispatch({
      type: SET_FILTERING_PROFILE_SCOPE,
      scope,
    });
  };
}

export function setFilteringProfileFilter(filter) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_FILTERING_PROFILE_FILTER,
      filter,
    });
    // Persist filtering profile
    requestUpdateFilteringProfile(
      getState().user,
      getState().resultMap.filteringProfile
    );
  };
}

// Removes applied filter on trait for given date
export function deleteFilteringProfileFilter(date) {
  return (dispatch, getState) => {
    dispatch({
      type: DELETE_FILTERING_PROFILE_FILTER,
      date,
    });
    requestUpdateFilteringProfile(
      getState().user,
      getState().resultMap.filteringProfile
    );
  };
}

export function setFilteringProfiles(filteringProfiles) {
  return (dispatch) => {
    dispatch({
      type: SET_FILTERING_PROFILES,
      filteringProfiles,
    });
  };
}

export function createFilteringProfile(filteringProfile) {
  return (dispatch) => {
    dispatch({
      type: CREATE_FILTERING_PROFILE,
      filteringProfile,
    });
  };
}

export function deleteFilteringProfile(filteringProfile) {
  return (dispatch) => {
    dispatch({
      type: DELETE_FILTERING_PROFILE,
      filteringProfile,
    });
  };
}

export function setFilteringProfile(filteringProfile) {
  return (dispatch) => {
    dispatch({
      type: SET_FILTERING_PROFILE,
      filteringProfile,
    });
  };
}

export function resetFilteringProfile() {
  return (dispatch) => {
    dispatch({
      type: RESET_FILTERING_PROFILE,
    });
  };
}

export function addGroupToFilteringProfileBlacklist(group) {
  return async (dispatch, getState) => {
    dispatch({
      type: ADD_GROUP_TO_FILTERING_PROFILE_BLACKLIST,
      group,
    });
    try {
      await requestUpdateFilteringProfile(
        getState().user,
        getState().resultMap.filteringProfile
      );
    } catch {
      dispatch({
        type: REMOVE_GROUP_FROM_FILTERING_PROFILE_BLACKLIST,
        group,
      });
    }
  };
}

export function removeGroupFromFilteringProfileBlacklist(group) {
  return async (dispatch, getState) => {
    dispatch({
      type: REMOVE_GROUP_FROM_FILTERING_PROFILE_BLACKLIST,
      group,
    });
    try {
      await requestUpdateFilteringProfile(
        getState().user,
        getState().resultMap.filteringProfile
      );
    } catch {
      dispatch({
        type: ADD_GROUP_TO_FILTERING_PROFILE_BLACKLIST,
        group,
      });
    }
  };
}

export function addGroupToFilteringProfileWhitelist(group) {
  return async (dispatch, getState) => {
    dispatch({
      type: ADD_GROUP_TO_FILTERING_PROFILE_WHITELIST,
      group,
    });
    try {
      await requestUpdateFilteringProfile(
        getState().user,
        getState().resultMap.filteringProfile
      );
    } catch {
      dispatch({
        type: REMOVE_GROUP_FROM_FILTERING_PROFILE_WHITELIST,
        group,
      });
    }
  };
}

export function removeGroupFromFilteringProfileWhitelist(group) {
  return async (dispatch, getState) => {
    dispatch({
      type: REMOVE_GROUP_FROM_FILTERING_PROFILE_WHITELIST,
      group,
    });
    try {
      await requestUpdateFilteringProfile(
        getState().user,
        getState().resultMap.filteringProfile
      );
    } catch {
      dispatch({
        type: ADD_GROUP_TO_FILTERING_PROFILE_WHITELIST,
        group,
      });
    }
  };
}

export function updateFilteringProfile(updatedProfile) {
  return async (dispatch, getState) => {
    const filteringProfile = getState().resultMap.filteringProfile;
    dispatch({
      type: UPDATE_FILTERING_PROFILE,
      filteringProfile: updatedProfile,
    });

    try {
      await requestUpdateFilteringProfile(getState().user, updatedProfile);
    } catch {
      dispatch({
        type: UPDATE_FILTERING_PROFILE,
        filteringProfile: filteringProfile,
      });
    }
  };
}

export function setExperimentsFilter(experiments) {
  return (dispatch) => {
    dispatch({
      type: SET_EXPERIMENTS_FILTER,
      experiments,
    });
  };
}

export function setModalitiesFilter(modalities) {
  return (dispatch) => {
    dispatch({
      type: SET_MODALITIES_FILTER,
      modalities,
    });
  };
}

export function setFocusedVarieties(focusedVarieties) {
  return (dispatch) => {
    dispatch({
      type: SET_FOCUSED_VARIETIES,
      focusedVarieties,
    });
  };
}

export function addFocusedVarieties(focusedVarieties) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_FOCUSED_VARIETIES,
      focusedVarieties: Array.from(
        new Set(
          getState().resultMap.focusedVarieties.concat(
            focusedVarieties.slice(0, MAX_GENOTYPE_SELECTION)
          )
        )
      ),
    });
  };
}

export function removeFocusedVariety(variety) {
  return (dispatch) => {
    dispatch({
      type: REMOVE_FOCUSED_VARIETY,
      variety,
    });
  };
}

export function setFavoriteVarieties(favoriteVarieties) {
  return (dispatch) => {
    dispatch({
      type: SET_FAVORITE_VARIETIES,
      favoriteVarieties,
    });
  };
}

export function setVisualizedVarieties(visualizedVarieties) {
  return (dispatch) => {
    dispatch({
      type: SET_VISUALIZED_VARIETIES,
      visualizedVarieties,
    });
  };
}

export function setLayerFilter(layer) {
  return (dispatch) => {
    dispatch({
      type: SET_LAYER_FILTER,
      layer,
    });
  };
}

export function setAttributes(attributes) {
  return (dispatch) => {
    dispatch({
      type: SET_ATTRIBUTES_FILTER,
      attributes,
    });
  };
}

export function fetchFeaturesByDate(site) {
  return (dispatch, getState) => {
    dispatch(refreshingFeaturesByDate());
    requestFeaturesPropertiesByDate(getState().user, site)
      .then((featuresByDate) => {
        // Prevent from overriding data
        if (getState().resultMap.featuresByDate.length === 0)
          dispatch(setFeaturesByDate(featuresByDate, getState().traits.all));
      })
      .catch((err) => {
        dispatch(addDangerAlert(err));
        dispatch({ type: FEATURES_BY_DATE_FAILED, trialId: site.id });
      });
  };
}

export function setSelectedContract(contract) {
  return (dispatch) => {
    dispatch({
      type: SET_SELECTED_CONTRACT,
      contract,
    });
  };
}

export function setAucData(aucData) {
  return (dispatch) => {
    dispatch({
      type: SET_AUC_DATA,
      aucData,
    });
  };
}

export function removeTraitFromAucData(traitLabel) {
  return (dispatch) => {
    dispatch({
      type: REMOVE_TRAIT_FROM_AUC_DATA,
      traitLabel,
    });
  };
}

export function upsertMapLayer(layer) {
  return (dispatch) => {
    dispatch({
      type: UPSERT_MAP_LAYER,
      layer,
    });
  };
}

export function setMapMode(mapMode) {
  return (dispatch) => {
    dispatch({
      type: SET_MAP_MODE,
      mapMode,
    });
  };
}

// `scoutingDates` is the [start, end] envelope the endpoint needs,
// `scoutingDays` the days actually ticked, as "yyyy-MM-dd". Both live in the
// store: the envelope alone cannot say which days inside it were picked.
export function setScoutingDates(scoutingDates, scoutingDays) {
  return (dispatch) => {
    dispatch({
      type: SET_SCOUTING_DATES,
      scoutingDates,
      scoutingDays,
    });
  };
}

export function addAnova(anova) {
  return (dispatch) => {
    dispatch({
      type: ADD_ANOVA,
      anova,
    });
  };
}

export function addTukey(anovaId, tukey, tukeyErrors) {
  return (dispatch) => {
    dispatch({
      type: ADD_TUKEY,
      anovaId,
      tukey,
      tukeyErrors,
    });
  };
}

export function setSelectedAnovaIndex(index) {
  return (dispatch) => {
    dispatch({
      type: SET_SELECTED_ANOVA_INDEX,
      anovaIndex: index,
    });
  };
}

export function resetAnova() {
  return (dispatch) => {
    dispatch({
      type: RESET_ANOVA,
    });
  };
}

export function setScoutingFeatures(scoutingFeatures) {
  return (dispatch) => {
    dispatch({
      type: SET_SCOUTING_FEATURES,
      scoutingFeatures,
    });
  };
}

export function setSelectedScoutingFeature(scoutingFeature) {
  return (dispatch) => {
    dispatch({
      type: SET_SELECTED_SCOUTING_FEATURE,
      scoutingFeature,
    });
  };
}

export function setScoutingTraits(traits) {
  return (dispatch) => {
    dispatch({
      type: SET_SCOUTING_TRAITS,
      traits,
    });
  };
}

export function setSelectedScoutingTrait(trait) {
  return (dispatch) => {
    dispatch({
      type: SET_SELECTED_SCOUTING_TRAIT,
      trait,
    });
  };
}

// Ticking days quickly fires one request per click and they do not come back
// in order: only the answer to the last one may be applied.
let lastScoutingRequest = 0;

export function resetScouting() {
  return (dispatch) => {
    // A request may still be in flight: bumping the counter drops its answer,
    // otherwise it repopulates the store just after this reset emptied it.
    lastScoutingRequest++;
    dispatch({
      type: RESET_SCOUTING,
    });
  };
}

// Quit the current site but keep the campaign and the company selected.
export function clearResultMapSite() {
  return (dispatch) => {
    lastScoutingRequest++;
    dispatch({
      type: CLEAR_RESULT_MAP_SITE,
    });
  };
}

// `dates` is the [start, end] envelope the endpoint needs, `selectedDays` the
// days actually asked for, as "yyyy-MM-dd".
export function fetchScoutingFeatures(dates, selectedDays) {
  const [startDate, endDate] = dates;
  return (dispatch, getState) => {
    const requestId = ++lastScoutingRequest;
    return requestFetchScoutingFeatures(
      getState().user,
      getState().resultMap.trial.id,
      new Date(startDate).toISOString(),
      new Date(endDate).toISOString()
    ).then((scoutingFeatures) => {
      if (requestId !== lastScoutingRequest) return;
      // The endpoint filters on an interval only, so picking two days that are
      // not consecutive brings back everything in between: drop what was not
      // asked for. Local day on both sides, like the list the user picked from.
      const asked = selectedDays?.length
        ? scoutingFeatures.filter(({ datetime }) =>
            selectedDays.includes(format(new Date(datetime), "yyyy-MM-dd"))
          )
        : scoutingFeatures;
      dispatch(setScoutingFeatures(asked));
    });
  };
}

export function setMapDisplayMode(value) {
  return (dispatch) => {
    dispatch({
      type: SET_MAP_DISPLAY_MODE,
      value,
    });
  };
}

export function setFilterByStatusMode() {
  return (dispatch, getState) => {
    const currentMode = getState().resultMap.filterByStatusMode;

    if (currentMode) dispatch({ type: RESET_FILTER_BY_STATUS });
    else
      dispatch({
        type: SET_FILTER_BY_STATUS_MODE,
        plotmapStatusMode: true,
      });
  };
}

// Plot Map colours its plots with selectedAttribute while on, grey otherwise.
export function setPlotMapColoring(value) {
  return (dispatch) => {
    dispatch({ type: SET_PLOT_MAP_COLORING, value });
  };
}

// Plot Map's own slider: the plots layer's opacity is the Results fill, a
// shared value made one tab's setting leak into the other.
export function setPlotMapOpacity(value) {
  return (dispatch) => {
    dispatch({ type: SET_PLOT_MAP_OPACITY, value });
  };
}

export function setPlotLabelProperty(value) {
  return (dispatch) => {
    dispatch({ type: SET_PLOT_LABEL_PROPERTY, value });
  };
}

export function setPlotLabelOpacity(value) {
  return (dispatch) => {
    dispatch({ type: SET_PLOT_LABEL_OPACITY, value });
  };
}

export function setPlotLabelsVisible(value) {
  return (dispatch) => {
    dispatch({ type: SET_PLOT_LABELS_VISIBLE, value });
  };
}

// True while the Toolbox linear ruler is open: a plot click places a ruler
// point, the map must not fly to the plot.
export function setLinearRulerActive(value) {
  return (dispatch) => {
    dispatch({ type: SET_LINEAR_RULER_ACTIVE, value });
  };
}

export function resetFilterByStatus() {
  return (dispatch) => {
    dispatch({
      type: RESET_FILTER_BY_STATUS,
    });
  };
}

export function enableEditionMode(value) {
  return (dispatch) => {
    dispatch({
      type: ENABLE_EDITION_MODE,
      editionModeEnabled: value,
    });
  };
}

// The palette being edited, not saved yet (null once saved). In the store so
// the editor can unmount (closed menu, other tab) without losing it.
export function setPendingFieldBookColors(colors) {
  return { type: SET_PENDING_FIELD_BOOK_COLORS, colors };
}

export function setSelectedAttribute(attribute) {
  return (dispatch) => {
    dispatch({
      type: SET_SELECTED_ATTRIBUTE,
      attribute,
    });
  };
}

export function setTrialExperimentStatus(status) {
  return (dispatch) => {
    dispatch({
      type: SET_TRIAL_EXPERIMENT_STATUS,
      status,
    });
  };
}
